import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  tooltipContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  tooltipTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
  },
  actionButton: {
    marginRight: "12px",
    cursor: "pointer",
  },
  buttonSmall: {
    height: "32px",
  },
  loadingButton: {
    marginRight: "12px",
    cursor: "progress",
  },
}));

export default styles;
